<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('pickupDisplay.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('pickupDisplay.pageTitle'),
            href: '/pickup-card-creations'
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-2">
            <div class="card border-0">
              <div class="card-body ts-bg-gray-900 ts-rounded-sm">
                <div class="text-gray-500">
                  <b>{{ $t('pickupDisplay.displaySetting') }}</b>
                </div>
              </div>
              <div class="widget-list rounded-bottom">
                <div class="mb-3 mt-3">
                  <label class="form-col-label control-label">{{
                    $t('pickupDisplay.gate')
                  }}</label>
                  <select class="form-control" v-model.number="device_id">
                    <option value="0">
                      {{ $t('pickupDisplay.notSpecify') }}
                    </option>
                    <option
                      v-for="(device, index) in devices"
                      :key="index"
                      :value="device.id"
                    >
                      {{ device.device_description }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-col-label control-label">{{
                    $t('pickupDisplay.repeatCall')
                  }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="repeatCall"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-col-label control-label">{{
                    $t('pickupDisplay.callInterval')
                  }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="second"
                  />
                  <small class="text-info">
                    {{ $t('pickupDisplay.second') }}
                  </small>
                </div>
                <div class="mb-3 tw-justify-between tw-flex tw-space-x-2">
                  <ts-button
                    class="btn-block btn-lg"
                    color="success"
                    @click.prevent="displayQueue"
                    >{{ $t('pickupDisplay.display') }}</ts-button
                  >
                  <ts-button
                    class="btn-block btn-lg"
                    color="success"
                    @click.prevent="tvModePickup"
                    >TV Mode</ts-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-10">
            <div id="container">
              <StudentPickupTable
                :studentPickupLoad="studentPickupLoad"
                @onStudentPickupLoad="studentPickupLoad = false"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import Display from './display.vue'
import StudentPickupTable from './student-pickup-table.vue'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'pickup-display-form',
  components: { StudentPickupTable },
  data () {
    return {
      loadingPreData: false,
      device_id: 0,
      repeatCall: 0,
      second: 0,
      suffixAudio: '',
      company: {},
      branch: {},
      studentPickupLoad: false,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('pickupDisplay', ['devices', 'click_close']),

    callInterval () {
      return parseInt(parseInt(this.second) * 1000)
    }
  },
  mounted () {
    if (localStorage.getItem('device_id')) {
      this.device_id = parseInt(localStorage.getItem('device_id'))
    }
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    async fetchResourceBeforeCreate () {
      this.loadingPreData = true
      await this.$store
        .dispatch('pickupDisplay/dataBeforeCreate')
        .then(response => {
          this.repeatCall = parseInt(response.repeat_call)
          this.suffixAudio = response.suffix_audio
          this.company = response.company
          this.branch = response.branch
          this.second = parseInt(response.call_interval) / 1000
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    displayQueue () {
      this.goFullScreen()
      this.$store.commit('pickupDisplay/SET_CLICK_CLOSE', false)
      this.display()
    },
    display () {
      localStorage.setItem('device_id', this.device_id)

      let filter = this.devices.filter(d => d.id == this.device_id)

      this.$modal.show(
        Display,
        {
          deviceId: this.device_id,
          deviceName: filter.length ? filter[0].device_description : '',
          suffix_audio: this.suffixAudio,
          repeatCall: parseInt(this.repeatCall),
          intervalCall: parseInt(parseInt(this.second) * 1000),
          company: this.company,
          branch: this.branch
        },
        {
          width: '100%',
          height: '100%',
          scrollable: false,
          clickToClose: false
        },
        {
          'before-open': this.beforeOpen,
          'before-close': () => {
            if (this.click_close) {
              this.beforeClose()
            } else {
              this.display()
            }
          }
        }
      )
    },
    goFullScreen () {
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    beforeOpen (event) {
      document.querySelector('body').classList.add('hide-body-scroll')
    },
    beforeClose (event) {
      document.querySelector('body').classList.remove('hide-body-scroll')
      this.closeFullscreen()
      this.studentPickupLoad = true
    },
    saveSetting () {
      this.$store
        .dispatch('pickupDisplay/setting', {
          repeat_call: this.repeatCall,
          call_interval: this.callInterval
        })
        .then(response => {
          // this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    tvModePickup(){
      window.location.href = window.location.origin + '/tv-mode-pickup.html'
    }
  },
  watch: {
    repeatCall: debounce(function (newVal) {
      if (newVal) {
        this.saveSetting()
      }
    }, 500),
    callInterval: debounce(function (newVal) {
      if (newVal) {
        this.saveSetting()
      }
    }, 500)
  }
}
</script>
